<template>
  <svg
    v-if="!props.active"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <mask id="path-1-inside-1_3669_9672" fill="white">
      <path
        d="M3.00021 15.5526C3.00021 15.8578 3.24763 16.1053 3.55284 16.1053C3.85805 16.1053 4.10547 15.8578 4.10547 15.5526C4.10547 15.2474 3.85805 15 3.55284 15C3.24763 15 3.00021 15.2474 3.00021 15.5526Z" />
    </mask>
    <path
      d="M3.00021 15.5526C3.00021 15.8578 3.24763 16.1053 3.55284 16.1053C3.85805 16.1053 4.10547 15.8578 4.10547 15.5526C4.10547 15.2474 3.85805 15 3.55284 15C3.24763 15 3.00021 15.2474 3.00021 15.5526Z"
      fill="#333333" />
    <path
      d="M3.00021 15.5526H4.10547C4.10547 15.2474 3.85805 15 3.55284 15V16.1053V17.2105C2.63721 17.2105 1.89494 16.4683 1.89494 15.5526H3.00021ZM3.55284 16.1053V15C3.24763 15 3.00021 15.2474 3.00021 15.5526H4.10547H5.21073C5.21073 16.4683 4.46847 17.2105 3.55284 17.2105V16.1053ZM4.10547 15.5526H3.00021C3.00021 15.8578 3.24763 16.1053 3.55284 16.1053V15V13.8947C4.46847 13.8947 5.21073 14.637 5.21073 15.5526H4.10547ZM3.55284 15V16.1053C3.85805 16.1053 4.10547 15.8578 4.10547 15.5526H3.00021H1.89494C1.89494 14.637 2.63721 13.8947 3.55284 13.8947V15Z"
      fill="#333333"
      mask="url(#path-1-inside-1_3669_9672)" />
    <path
      d="M21.1055 2.55273C20.8004 2.55285 20.5527 2.80033 20.5527 3.10547C20.5528 3.41055 20.8004 3.65809 21.1055 3.6582C21.4106 3.6582 21.6581 3.41061 21.6582 3.10547C21.6582 2.80026 21.4107 2.55273 21.1055 2.55273Z"
      fill="#333333"
      stroke="#333333"
      stroke-width="1.10526" />
    <path
      d="M8.82463 5L11.9998 5L15.1754 5M8.82463 5L5.64943 5L3 10.3571L7.49992 10.3571M8.82463 5L7.49992 10.3571M15.1754 5L18.3509 5L20.9997 10.3571L16.4998 10.3571M15.1754 5L16.4998 10.3571M7.49992 10.3571L11.9998 10.3571L16.4998 10.3571M12.0002 20L3.00033 10.3571L21 10.3571L12.0002 20Z"
      stroke="#4D4D4D"
      stroke-width="1.5"
      stroke-linecap="square"
      stroke-linejoin="round" />
  </svg>

  <svg
    v-else
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_3669_9671)">
      <g filter="url(#filter0_d_3669_9671)">
        <mask id="path-1-inside-1_3669_9671" fill="white">
          <path
            d="M3.00021 15.5526C3.00021 15.8578 3.24763 16.1053 3.55284 16.1053C3.85805 16.1053 4.10547 15.8578 4.10547 15.5526C4.10547 15.2474 3.85805 15 3.55284 15C3.24763 15 3.00021 15.2474 3.00021 15.5526Z" />
        </mask>
        <path
          d="M3.00021 15.5526C3.00021 15.8578 3.24763 16.1053 3.55284 16.1053C3.85805 16.1053 4.10547 15.8578 4.10547 15.5526C4.10547 15.2474 3.85805 15 3.55284 15C3.24763 15 3.00021 15.2474 3.00021 15.5526Z"
          fill="white" />
        <path
          d="M3.00021 15.5526H4.10547C4.10547 15.2474 3.85805 15 3.55284 15V16.1053V17.2105C2.63721 17.2105 1.89494 16.4683 1.89494 15.5526H3.00021ZM3.55284 16.1053V15C3.24763 15 3.00021 15.2474 3.00021 15.5526H4.10547H5.21073C5.21073 16.4683 4.46847 17.2105 3.55284 17.2105V16.1053ZM4.10547 15.5526H3.00021C3.00021 15.8578 3.24763 16.1053 3.55284 16.1053V15V13.8947C4.46847 13.8947 5.21073 14.637 5.21073 15.5526H4.10547ZM3.55284 15V16.1053C3.85805 16.1053 4.10547 15.8578 4.10547 15.5526H3.00021H1.89494C1.89494 14.637 2.63721 13.8947 3.55284 13.8947V15Z"
          fill="white"
          mask="url(#path-1-inside-1_3669_9671)" />
      </g>
      <g filter="url(#filter1_d_3669_9671)">
        <path
          d="M20.0004 3.10533C20.0004 3.71575 20.4953 4.21059 21.1057 4.21059C21.7161 4.21059 22.2109 3.71575 22.2109 3.10533C22.2109 2.49491 21.7161 2.00006 21.1057 2.00006C20.4953 2.00006 20.0004 2.49491 20.0004 3.10533Z"
          fill="white" />
        <path
          d="M21.1055 2.55273C20.8004 2.55285 20.5527 2.80033 20.5527 3.10547C20.5528 3.41055 20.8004 3.65809 21.1055 3.6582C21.4106 3.6582 21.6581 3.41061 21.6582 3.10547C21.6582 2.80026 21.4107 2.55273 21.1055 2.55273Z"
          stroke="white"
          stroke-width="1.10526" />
      </g>
      <path d="M16 10L12 20L6.5 14L9 5H15L16 10Z" fill="url(#paint0_linear_3669_9671)" />
      <g filter="url(#filter2_d_3669_9671)">
        <g clip-path="url(#paint1_diamond_3669_9671_clip_path)" data-figma-skip-parse="true">
          <g transform="matrix(0 0.0035 -0.0035 0 19.5 17.5)">
            <rect
              x="0"
              y="0"
              width="1315.79"
              height="1315.79"
              fill="url(#paint1_diamond_3669_9671)"
              opacity="1"
              shape-rendering="crispEdges" />
            <rect
              x="0"
              y="0"
              width="1315.79"
              height="1315.79"
              transform="scale(1 -1)"
              fill="url(#paint1_diamond_3669_9671)"
              opacity="1"
              shape-rendering="crispEdges" />
            <rect
              x="0"
              y="0"
              width="1315.79"
              height="1315.79"
              transform="scale(-1 1)"
              fill="url(#paint1_diamond_3669_9671)"
              opacity="1"
              shape-rendering="crispEdges" />
            <rect
              x="0"
              y="0"
              width="1315.79"
              height="1315.79"
              transform="scale(-1)"
              fill="url(#paint1_diamond_3669_9671)"
              opacity="1"
              shape-rendering="crispEdges" />
          </g>
        </g>
        <circle
          cx="19.5"
          cy="17.5"
          r="3.5"
          data-figma-gradient-fill="{&#34;type&#34;:&#34;GRADIENT_DIAMOND&#34;,&#34;stops&#34;:[{&#34;color&#34;:{&#34;r&#34;:0.85098040103912354,&#34;g&#34;:0.85098040103912354,&#34;b&#34;:0.85098040103912354,&#34;a&#34;:1.0},&#34;position&#34;:0.0},{&#34;color&#34;:{&#34;r&#34;:1.0,&#34;g&#34;:1.0,&#34;b&#34;:1.0,&#34;a&#34;:0.0},&#34;position&#34;:1.0}],&#34;stopsVar&#34;:[{&#34;color&#34;:{&#34;r&#34;:0.85098040103912354,&#34;g&#34;:0.85098040103912354,&#34;b&#34;:0.85098040103912354,&#34;a&#34;:1.0},&#34;position&#34;:0.0},{&#34;color&#34;:{&#34;r&#34;:1.0,&#34;g&#34;:1.0,&#34;b&#34;:1.0,&#34;a&#34;:0.0},&#34;position&#34;:1.0}],&#34;transform&#34;:{&#34;m00&#34;:4.2862641163969855e-16,&#34;m01&#34;:-7.0,&#34;m02&#34;:23.0,&#34;m10&#34;:7.0,&#34;m11&#34;:4.2862641163969855e-16,&#34;m12&#34;:14.0},&#34;opacity&#34;:1.0,&#34;blendMode&#34;:&#34;NORMAL&#34;,&#34;visible&#34;:true}"
          shape-rendering="crispEdges" />
      </g>
      <path d="M19.474 19.5194V15.5194M21.5 17.499H17.5" stroke="white" stroke-width="1.5" />
      <path
        d="M8.82463 5L11.9998 5L15.1754 5M8.82463 5L5.64943 5L3 10.3571L7.49992 10.3571M8.82463 5L7.49992 10.3571M15.1754 5L18.3509 5L20.9997 10.3571L16.4998 10.3571M15.1754 5L16.4998 10.3571M7.49992 10.3571L11.9998 10.3571L16.4998 10.3571M12.0002 20L3.00033 10.3571L21 10.3571L12.0002 20Z"
        stroke="url(#paint2_linear_3669_9671)"
        stroke-width="1.5"
        stroke-linecap="square"
        stroke-linejoin="round" />
    </g>
    <defs>
      <filter
        id="filter0_d_3669_9671"
        x="0.789474"
        y="12.7895"
        width="5.52652"
        height="5.52652"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB">
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha" />
        <feOffset />
        <feGaussianBlur stdDeviation="1.10526" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3669_9671" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_3669_9671"
          result="shape" />
      </filter>
      <filter
        id="filter1_d_3669_9671"
        x="17.79"
        y="-0.210526"
        width="6.6315"
        height="6.63199"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB">
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha" />
        <feOffset />
        <feGaussianBlur stdDeviation="1.10526" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3669_9671" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_3669_9671"
          result="shape" />
      </filter>
      <filter
        id="filter2_d_3669_9671"
        x="11.5789"
        y="14"
        width="15.8421"
        height="15.8421"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB">
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha" />
        <feOffset dy="4.42105" />
        <feGaussianBlur stdDeviation="2.21053" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3669_9671" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_3669_9671"
          result="shape" />
      </filter>
      <clipPath id="paint1_diamond_3669_9671_clip_path">
        <circle cx="19.5" cy="17.5" r="3.5" shape-rendering="crispEdges" />
      </clipPath>
      <linearGradient
        id="paint0_linear_3669_9671"
        x1="8.5"
        y1="15"
        x2="17.8037"
        y2="5.14725"
        gradientUnits="userSpaceOnUse">
        <stop stop-color="#8F42FF" stop-opacity="0" />
        <stop offset="1" stop-color="#8F42FF" />
      </linearGradient>
      <linearGradient
        id="paint1_diamond_3669_9671"
        x1="0"
        y1="0"
        x2="500"
        y2="500"
        gradientUnits="userSpaceOnUse">
        <stop stop-color="#D9D9D9" />
        <stop offset="1" stop-color="white" stop-opacity="0" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_3669_9671"
        x1="33"
        y1="40.5"
        x2="38.9419"
        y2="9.53298"
        gradientUnits="userSpaceOnUse">
        <stop offset="0.00423669" />
        <stop offset="1" stop-color="#8F42FF" />
      </linearGradient>
      <clipPath id="clip0_3669_9671">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>

<script setup>
const props = defineProps({
  active: {
    type: Boolean,
    default: false,
  },
});
</script>
